import {gql} from 'apollo-angular'

const PIPELINE_FIELD_FILTERS_FRAGMENT = gql`
    fragment PipelineFieldFilterData on PipelineFieldFilter {
      id
      name
      field
      id_field
      format
      json_parent_id
      is_typeahead
      is_multiselect
      is_filterable
      is_sortable
      is_grouped
      sort_type
      model
      special_lookup
      is_exportable
      example
      summary_example
      as_combined_columns_example
      as_columns_example
      active
    }
`

const PIPELINE_FIELD_FRAGMENT = gql`
    fragment PipelineFieldData on PipelineField {
      id
      category
      mt_column
      display_format
      is_json
      json_key_match
      save_type
      source_table
      source_column
      is_editable
      active
    }
`

const PIPELINE_VIEW_FILTER_FRAGMENT = gql`
    fragment PipelineViewFilterData on PipelineViewFilter {
      id
      name
      group
      pipelineViewType {
        name
        id
      }
      pipeline_view_id
      pipelineView {
        id
        name
        default_fields
      }
      filter
      sort
      group_id
      acls {
        permissions {
          id
          _edit
          _delete
        }
        acc {
          id
          user {
            person {
              id
              name
            }
          }
          group {
            id
            name
          }
        }
      }
      relatedGroup {
        id
        name
        groupMembers {
          user {
            person {
              id
              name
            }
          }
          groupMemberGroup {
            id
            group {
              id
              groupMembers {
                user {
                  person {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
      person_id
      person {
        name
        id
      }
      modified
      associated_sponsor_id
      associatedSponsor {
        name
        organizations {
          name
        }
      }
      associatedOrganization {
        name
        id
      }

    }
`
export var get_pipeline_field_filters = gql`
    query pipelineFieldFilters {
      pipelineFieldFilters {
        ...PipelineFieldFilterData
        children {
          ...PipelineFieldFilterData
        }
      }
      pipelineFields {
        ...PipelineFieldData
      }
    }
    ${PIPELINE_FIELD_FILTERS_FRAGMENT}
    ${PIPELINE_FIELD_FRAGMENT}
`

export var get_pipeline_field = gql`
    query pipelineFields {
      pipelineFields {
        ...PipelineFieldData
      }
    }
    ${PIPELINE_FIELD_FRAGMENT}
`

export var get_pipeline_view_filters = gql`
    query pipelineViewFilters {
      global: pipelineViewFilters(hasPipelineViewType: { column: NAME, operator: EQ, value: "Global" }){
        ...PipelineViewFilterData
      }
      owned: pipelineViewFilters(hasPipelineViewType: { column: NAME, operator: EQ, value: "Private" }){
        ...PipelineViewFilterData
      }
      me {
        permissionsForResource(resourceType: PIPELINEVIEWFILTER) {
          _edit
          _delete
        }
        user_profile {
          user {
            person {
              id
            }
            groupsFlattened {
              id
              name
            }
            permissionPipelines{
              pipeline {
                ...PipelineViewFilterData
              }
              _edit
              _delete
            }
            groups {
              id
              name
              groupMembers {
                user {
                  person {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
    ${PIPELINE_VIEW_FILTER_FRAGMENT}
`

export var get_selections_by_model = gql`
    query pipelineModelSelection($model: String!, $with: [String!]){
      pipelineModelFieldSelection(model: $model, with: $with)
    }
`
export var get_base_pipeline_views = gql`
    query getBaseViews {
      getBaseViews {
        id
        name
        default_fields
      }
    }
`

export var get_group_list = gql`
    query getGroups {
      getGroups {
        id
        name
        groupType {
          name
        }
        groupMembers {
          user {
            person {
              id
              name
            }
          }
        }
      }
      get_active_users {
        name
        id
        user {
          id
        }
      }
    }
`

export var get_filtered_pipeline = gql`
    query getFilteredPipeline($pipeline_view_filter_id: ID, $pipeline_view_id: ID, $filter: JSON, $sort: JSON, $group: JSON){
      getFilteredPipeline(pipeline_view_filter_id: $pipeline_view_filter_id, pipeline_view_id: $pipeline_view_id, filter: $filter, sort: $sort, group: $group)
    }
`

export var get_filtered_tags = gql`
    query getProjectTags($ids: [ID!]!){
      projectTags(project_ids: $ids)
    }
`

export var get_single_pipeline = gql`
    query getSinglePipeline($id: ID!){
      getSinglePipeline(id: $id)
      project(id: $id){
        projectPricingDetail {
          non_cra_execution
        }
        projectDates {
          date
          dateType {
            name
            model
          }
        }

      }
    }
`

export var get_sub_filters = gql`
    query getExportFilterList{
      attributes: pipelineModelFieldSelection(model: "AttributeType", with: ["attributes"])
    }
`

export var delete_permission = gql`
  mutation deletePipelinePermission($id:ID!){
    delete_permission(id: $id){
      id
    }
  }
`

export var tagged_participants_by_project = gql`
    query project($id: ID!){
      project(id: $id){
        taggedParticipants {
          person {
            entity {
              entity_types {
                type {
                  name
                  tagType {
                    name
                  }
                }
              }
            }
          }
          organization {
            entity {
              entity_types {
                type {
                  name
                  tagType {
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
`

export var save_pipeline_filter = gql`
    mutation savePipelineFilter(
      $name: String!,
      $pipeline_view_type_id: ID!,
      $pipeline_view_id: ID!,
      $group: JSON!,
      $sort: JSON!,
      $filter:JSON!,
      $group_id: ID,
      $person_id: ID,
      $associated_sponsor_id: ID,
      $associated_organization_id: ID ){
      createPipelineViewFilter(
        name: $name,
        pipeline_view_type_id: $pipeline_view_type_id,
        pipeline_view_id: $pipeline_view_id,
        sort: $sort,
        group: $group,
        filter: $filter,
        group_id: $group_id,
        person_id: $person_id
        associated_sponsor_id: $associated_sponsor_id,
        associated_organization_id: $associated_organization_id
      ){
          name
          filter
          sort
          group
      }
    }
  `

export var delete_pipeline_filter = gql`
    mutation deletePipelineViewFilter($id: ID!){
      deletePipelineViewFilter(id: $id){
        id
      }
    }
`

export var update_pipeline_filter = gql`
    mutation updatePipelineViewFilter($id: ID!, $name: String, $pipeline_view_id: ID, $group: JSON, $sort: JSON, $filter: JSON, $group_id: ID, $person_id: ID, $associated_sponsor_id: ID, $associated_organization_id: ID){
      updatePipelineViewFilter(id: $id, name: $name, pipeline_view_id: $pipeline_view_id, group: $group, sort: $sort, filter: $filter, group_id: $group_id, person_id: $person_id, associated_sponsor_id: $associated_sponsor_id, associated_organization_id: $associated_organization_id){
        name
        filter
        sort
        group
      }
    }
`

export var call_single_participant = gql`
    query callSingleParticipant($id: ID!){
      participantById(id: $id){
        person {
          id
          name
        }
        organization {
          id
          name
        }
        sponsor {
          id
          name
        }
      }
    }
`

export var share_pipeline_filter = gql`
    mutation sharePipeline($id: ID!, $input: [SharePipelineFilterInput!]!, $group_id:ID, $person_id: ID){
      sharePipeline(id: $id, input: $input){
        id
      }
      updatePipelineViewFilter(id: $id, group_id: $group_id, person_id: $person_id){
        id
      }
    }
`

export var search_investors_orgs_for_pipelines = gql`
    query searchInvestorsForPipelines($searchLike: String!, $search: String!, $limit: Int!){
      search_sponsors(
        first: $limit
        name: $searchLike
        orderByInstr: [{ column: NAME, search: $search, order: ASC }]
      ) {
        data {
          id
          name
        }
      }
      search_organizations(
        first: $limit
        name: $searchLike
        orderByInstr: [{ column: NAME, search: $search, order: ASC }]
      ) {
        data {
          id
          name
          entity {
            entity_types {
              type {
                name
                id
                tagType {
                  name
                }
              }
            }
          }
        }
      }
    }
`
